import React, { useEffect, useState } from "react";
import styles from "./userlist.module.css";
import Helmet from "react-helmet";
import Footer from "../../components/Footer";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, MenuItem, Select, Slide, Snackbar, TablePagination, Typography } from "@mui/material";
import { ArrowLeft, Home, MoreVertical, Plus, Search, Send, Trash2, UserCheck, UserX, X, ChevronDown, ChevronUp, Code } from "react-feather";
import { Dropdown } from "react-bootstrap";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import Loader from "../../components/Loader";
import { TableLoaderSmall } from "../../components/LoaderC";
import UserAdd from "./components/AddForm";
import { toast } from 'react-smart-toaster';
import { AddLogCallAPI } from "../../components/AddLogs";
import PeoplePageTitle from "../tenants/components/PeoplePageTitle";
import UserDetails from "./components/UserDetails";
import { formatPhoneNumberIntl } from "react-phone-number-input";

const UserList = () => {
  const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [propertyList, setPropertyList] = useState([]);
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [filterData, setFilterData] = useState({ searchKey: "", role: "all", property: "all", status: "all", hrMode: "all" });
  const [quickFilter, setQuickFilter] = useState("all");
  const [sortItem, setSortItem] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");
  const [activeDropdownId, setActiveDropdownId] = useState(null);

  const changeSortOrder = (item) => {
    if (item === sortItem) {
      setSortOrder(prev => prev === "asc" ? "desc" : "asc");
    } else {
      setSortOrder("asc");
      setSortItem(item);
    }
  };
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [archiveModalOpen, setArchiveModalOpen] = useState(false);
  const [selectecId, setSelectecId] = useState(0);
  const [isArchive, setIsArchive] = useState(false);
  const [perPage, setPerPage] = useState(8);
  const [roleList, setRoleList] = useState([]);
  const [prosDetails, setProsDetails] = React.useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    const fetchRoles = () => {
      return axios.post('https://' + process.env.REACT_APP_AUTH0_DOMAIN + '/oauth/token', { "client_id": process.env.REACT_APP_AUTH0_AUDIENCE_CLIENT_ID, "client_secret": process.env.REACT_APP_AUTH0_AUDIENCE_CLIENT_SECRET, "audience": 'https://' + process.env.REACT_APP_AUTH0_DOMAIN + "/api/v2/", "grant_type": "client_credentials" }, {
        'access-control-allow-origin': '*',
      }).then(response => {
        let managementToken = response?.data?.access_token;

        axios.get('https://' + process.env.REACT_APP_AUTH0_DOMAIN + '/api/v2/roles', {
          headers: {
            Authorization: `Bearer ${managementToken}`,
          }
        }).then(response2 => {
          let roleListTemp = response2?.data?.filter(i => i?.name !== "Super Admin");
          setRoleList(roleListTemp);
        }).catch(() => { });
      }).catch(() => { });
    }

    fetchRoles();
  }, []);

  useEffect(() => {
    const getUserList = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_APPLICANT_API_URL + "v1/get-all-properties", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        setPropertyList([{ value: 'all', label: 'Any' }].concat(response.data.data));
      }).catch(() => {
        setPropertyList([]);
      });
    }

    getUserList();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    const getUserList = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_USER_API_URL + "v1/users", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
      }).catch(() => {
        setContentLoading(false);
      });
    }

    getUserList();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    let filteredDataTemp = allData || [];

    // 1. Quick Filter Pills
    if (quickFilter === "active") {
      filteredDataTemp = filteredDataTemp.filter(i => i.is_archived !== 1);
    } else if (quickFilter === "pending_verify") {
      filteredDataTemp = filteredDataTemp.filter(i => i.is_verified !== 1);
    } else if (quickFilter === "hr_mode") {
      filteredDataTemp = filteredDataTemp.filter(i => i.is_hr_mode === 1);
    } else if (quickFilter === "disabled") {
      filteredDataTemp = filteredDataTemp.filter(i => i.is_archived === 1);
    }

    // 2. Search Text
    if (filterData.searchKey && filterData.searchKey !== "") {
      let inputVal = filterData.searchKey.toLowerCase();
      filteredDataTemp = filteredDataTemp.filter((item) => {
        let phoneStr1 = item?.phone?.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        let phoneStr2 = item?.phone;
        return (
          (item.name || "").toLowerCase().includes(inputVal) ||
          (item.role || "").toLowerCase().includes(inputVal) ||
          phoneStr1?.includes(inputVal) ||
          phoneStr2?.includes(inputVal) ||
          (item.email || "").toLowerCase().includes(inputVal)
        );
      });
    }

    // 3. Property Dropdown
    if (filterData.property !== "" && filterData.property !== "all") {
      filteredDataTemp = filteredDataTemp.filter((i) => i.property_ids && i.property_ids.indexOf(filterData.property) > -1);
    }

    // 4. Role Dropdown
    if (filterData.role !== "" && filterData.role !== "all") {
      filteredDataTemp = filteredDataTemp.filter((i) => i.role_id === filterData.role);
    }

    // 5. Status Dropdown
    if (filterData.status !== "" && filterData.status !== "all") {
      const checkArchived = filterData.status === "disabled" ? 1 : 0;
      filteredDataTemp = filteredDataTemp.filter((i) => i.is_archived === checkArchived);
    }

    // 6. HR Mode Dropdown
    if (filterData.hrMode !== "" && filterData.hrMode !== "all") {
      const checkHr = filterData.hrMode === "on" ? 1 : 0;
      filteredDataTemp = filteredDataTemp.filter((i) => i.is_hr_mode === checkHr);
    }

    // 7. Dynamic Sort
    filteredDataTemp = [...filteredDataTemp];
    if (sortItem === "employee") {
      filteredDataTemp.sort((a, b) => {
        const valA = (a.name || "").toLowerCase();
        const valB = (b.name || "").toLowerCase();
        if (valA < valB) return sortOrder === "asc" ? -1 : 1;
        if (valA > valB) return sortOrder === "asc" ? 1 : -1;
        return 0;
      });
    } else if (sortItem === "property") {
      filteredDataTemp.sort((a, b) => {
        const valA = (a.property_arr?.[0] || "").toLowerCase();
        const valB = (b.property_arr?.[0] || "").toLowerCase();
        if (valA < valB) return sortOrder === "asc" ? -1 : 1;
        if (valA > valB) return sortOrder === "asc" ? 1 : -1;
        return 0;
      });
    } else if (sortItem === "role") {
      filteredDataTemp.sort((a, b) => {
        const valA = (a.role || "").toLowerCase();
        const valB = (b.role || "").toLowerCase();
        if (valA < valB) return sortOrder === "asc" ? -1 : 1;
        if (valA > valB) return sortOrder === "asc" ? 1 : -1;
        return 0;
      });
    } else if (sortItem === "verification") {
      filteredDataTemp.sort((a, b) => {
        const valA = a.is_verified || 0;
        const valB = b.is_verified || 0;
        return sortOrder === "asc" ? valA - valB : valB - valA;
      });
    } else if (sortItem === "hrMode") {
      filteredDataTemp.sort((a, b) => {
        const valA = a.is_hr_mode || 0;
        const valB = b.is_hr_mode || 0;
        return sortOrder === "asc" ? valA - valB : valB - valA;
      });
    } else if (sortItem === "schedule") {
      filteredDataTemp.sort((a, b) => {
        const valA = a.checkin_time || "";
        const valB = b.checkin_time || "";
        if (valA < valB) return sortOrder === "asc" ? -1 : 1;
        if (valA > valB) return sortOrder === "asc" ? 1 : -1;
        return 0;
      });
    } else if (sortItem === "status") {
      filteredDataTemp.sort((a, b) => {
        const valA = a.is_archived || 0;
        const valB = b.is_archived || 0;
        return sortOrder === "asc" ? valA - valB : valB - valA;
      });
    } else {
      // Default: Last entries should be shown first (ID descending)
      filteredDataTemp.sort((a, b) => {
        return (b.id ?? 0) - (a.id ?? 0);
      });
    }

    setFilteredData(filteredDataTemp);
  }, [allData, filterData, quickFilter, sortOrder, sortItem]);

  const userAdd = (data) => {
    setAllData(prev => {
      return [data].concat(prev);
    })
  }

  const userUpdate = (data) => {
    setAllData(prev => {
      let updateList = prev?.map(item => {
        if (item?.id === data?.id)
          return data;
        else
          return item;
      })
      return updateList;
    })
    setSelectedUser(data);
  }

  const confirmDelete = async () => {
    setDeleteModalOpen(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.delete(process.env.REACT_APP_USER_API_URL + 'v1/users-new-phone/' + selectecId, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(response => {
      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);
      setLoading(false);

      let respData = response.data.data;

      setAllData(prev => {
        let updateList = prev?.filter(i => i?.id !== selectecId);
        return updateList;
      })
      setSelectecId(0);

      let logData = {
        'title': 'User is deleted',
        'description': [
          'Name: ' + respData.name,
          'Email: ' + respData.email,
          'Role: ' + respData.role
        ]
      }
      AddLogCallAPI(logData, token);
    }).catch(error => {
      if (typeof error.response !== 'undefined')
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const confirmArchive = async () => {
    setArchiveModalOpen(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    let is_archived = isArchive ? 0 : 1;
    axios.put(process.env.REACT_APP_USER_API_URL + 'v1/users/' + selectecId, { is_archived: is_archived }, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }
    ).then(response => {
      let respData = response.data.data;

      setSnackbarOpen(true);
      setSnackbarMsg((respData.is_archived ? 'User has been disabled.' : 'User has been enabled.'));
      setLoading(false);

      userUpdate(respData);

      let logData = {
        'title': (respData.is_archived ? 'User has been disabled.' : 'User has been enabled.'),
        'description': [
          'Name: ' + respData.name,
          'Email: ' + respData.email,
          'Role: ' + respData.role
        ]
      }
      AddLogCallAPI(logData, token);
    }).catch(error => {
      if (typeof error.response !== 'undefined')
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const sendVerificationLink = async (id) => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios(process.env.REACT_APP_USER_API_URL + 'v1/send-verification-link/' + id, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(response => {
      setLoading(false);
      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);
    }).catch(error => {
      setLoading(false);
      if (typeof error.response !== 'undefined')
        toast.error(error.response.data.message);
    });
  }

  const OpenTaskDetails = (item) => {
    setSelectedUser(item);
    setProsDetails(true);
  };
  const CloseTaskDetails = () => {
    setProsDetails(false);
    setSelectedUser(null);
  };

  // const toggleHrMode = async (id, currentValue) => {
  //   try {
  //     setLoading(true);

  //     const token = await getAccessTokenSilently({
  //       audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  //     });

  //     const updatedValue = currentValue === 1 ? 0 : 1;

  //     const response = await axios.put(
  //       process.env.REACT_APP_USER_API_URL + `v1/users/${id}`,
  //       {
  //         is_hr_mode: updatedValue,
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     const updatedUser = response.data.data;

  //     // Update local state
  //     setAllData((prev) =>
  //       prev.map((user) =>
  //         user.id === id ? updatedUser : user
  //       )
  //     );

  //     setSnackbarOpen(true);
  //     setSnackbarMsg(response.data.message);

  //   } catch (error) {
  //     if (typeof error.response !== "undefined") {
  //       toast.error(error.response.data.message);
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const totalCount = allData.length;
  const activeCount = allData.filter(i => i.is_archived !== 1).length;
  const hrModeCount = allData.filter(i => i.is_hr_mode === 1).length;
  const pendingVerifyCount = allData.filter(i => i.is_verified !== 1).length;
  const disabledCount = allData.filter(i => i.is_archived === 1).length;

  return (<>
    {loading && <Loader />}
    <Helmet title="Employees" />

    <div className={`${styles.pageTitleWrap}`}>
      <PeoplePageTitle defaultPage={'Employees'} />
      <Typography display="inline" className={`${styles.pageTitle} ${styles.Big}`}>Employees</Typography>
      <nav aria-label="breadcrumb">
        <ol className={`${styles.breadcrumb}`}>
          <li className={`${styles.breadcrumbItem}`}><span><Home /></span>HR</li>
          <li className={`${styles.breadcrumbItem} ${styles.active}`}>Employees</li>
        </ol>
      </nav>
    </div>

    <div className={styles.statsSubHeader}>
      <span className={styles.statItem}>{totalCount} employees</span>
      <span className={styles.statDot}></span>
      <span className={styles.statItem}>{activeCount} active</span>
      <span className={styles.statDot}></span>
      <span className={styles.statItem}>{hrModeCount} HR mode enabled</span>
      <span className={styles.statDot}></span>
      <span className={styles.statItem}>{pendingVerifyCount} pending verification</span>
    </div>

    <div className={`${styles.BodyCon}`}>

      {/* Filter and Search controls */}
      <div className={styles.filterControlsRow}>
        <div className={styles.searchWrapper}>
          <Search className={styles.searchIcon} />
          <input
            type="text"
            className={styles.searchInput}
            value={filterData.searchKey}
            placeholder="Search employees by name, email or phone..."
            onChange={(e) => setFilterData(prev => ({ ...prev, searchKey: e.target.value }))}
          />
        </div>

        <div className={styles.dropdownFiltersGroup}>
          <FormControl className={styles.selectFormControl}>
            <Select
              value={filterData.property}
              onChange={(e) => setFilterData(prev => ({ ...prev, property: e.target.value }))}
              displayEmpty
            >
              <MenuItem value="all">All Properties</MenuItem>
              {propertyList?.filter(i => i.value !== 'all').map(item => (
                <MenuItem key={item?.value} value={item?.value}>{item?.label}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl className={styles.selectFormControl}>
            <Select
              value={filterData.role}
              onChange={(e) => setFilterData(prev => ({ ...prev, role: e.target.value }))}
              displayEmpty
            >
              <MenuItem value="all">All Roles</MenuItem>
              {roleList?.map(item => (
                <MenuItem key={item?.id} value={item?.id}>{item?.name}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl className={styles.selectFormControl}>
            <Select
              value={filterData.status}
              onChange={(e) => setFilterData(prev => ({ ...prev, status: e.target.value }))}
              displayEmpty
            >
              <MenuItem value="all">All Statuses</MenuItem>
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="disabled">Disabled</MenuItem>
            </Select>
          </FormControl>

          <FormControl className={styles.selectFormControl}>
            <Select
              value={filterData.hrMode}
              onChange={(e) => setFilterData(prev => ({ ...prev, hrMode: e.target.value }))}
              displayEmpty
            >
              <MenuItem value="all">HR Mode: All</MenuItem>
              <MenuItem value="on">HR Mode: On</MenuItem>
              <MenuItem value="off">HR Mode: Off</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className={styles.actionButtonsGroup}>
          {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("user:create") > -1 && (
            <button className={styles.addEmployeeBtn} onClick={() => setAddModalOpen(true)}>
              <Plus />
              <span>Add Employee</span>
            </button>
          )}
        </div>
      </div>

      {/* Quick Filter Pills */}
      <div className={styles.quickFiltersRow}>
        <button className={`${styles.filterPill} ${quickFilter === "all" ? styles.filterPillActive : ""}`} onClick={() => setQuickFilter("all")}>
          All <span className={styles.pillCount}>{totalCount}</span>
        </button>
        <button className={`${styles.filterPill} ${quickFilter === "active" ? styles.filterPillActive : ""}`} onClick={() => setQuickFilter("active")}>
          Active <span className={styles.pillCount}>{activeCount}</span>
        </button>
        <button className={`${styles.filterPill} ${quickFilter === "pending_verify" ? styles.filterPillActive : ""}`} onClick={() => setQuickFilter("pending_verify")}>
          Pending Verification <span className={styles.pillCount}>{pendingVerifyCount}</span>
        </button>
        <button className={`${styles.filterPill} ${quickFilter === "hr_mode" ? styles.filterPillActive : ""}`} onClick={() => setQuickFilter("hr_mode")}>
          HR Mode On <span className={styles.pillCount}>{hrModeCount}</span>
        </button>
        <button className={`${styles.filterPill} ${quickFilter === "disabled" ? styles.filterPillActive : ""}`} onClick={() => setQuickFilter("disabled")}>
          Disabled <span className={styles.pillCount}>{disabledCount}</span>
        </button>
      </div>

      <div className={`${styles.mainCardDiv}`}>
        <div className={`${styles.mainCard}`}>
          {contentLoading && <div className="Loader TableLoader"><TableLoaderSmall /></div>}

          {!contentLoading && <div className={styles.controlPane}>

            {/* Employee Table */}
            {filteredData.length > 0 && (
              <div className={styles.tableContainer}>
                <table className={styles.employeeTable}>
                  <thead>
                    <tr>
                      <th onClick={() => changeSortOrder("employee")} className={styles.clickableHeader}>
                        <span className={styles.sortableHeader}>
                          Employee
                          {sortItem === "employee" && sortOrder === "asc" && <ChevronDown />}
                          {sortItem === "employee" && sortOrder === "desc" && <ChevronUp />}
                          {sortItem !== "employee" && <Code className={styles.Normal} />}
                        </span>
                      </th>
                      <th onClick={() => changeSortOrder("property")} className={styles.clickableHeader}>
                        <span className={styles.sortableHeader}>
                          Property
                          {sortItem === "property" && sortOrder === "asc" && <ChevronDown />}
                          {sortItem === "property" && sortOrder === "desc" && <ChevronUp />}
                          {sortItem !== "property" && <Code className={styles.Normal} />}
                        </span>
                      </th>
                      <th onClick={() => changeSortOrder("job_title")} className={styles.clickableHeader}>
                        <span className={styles.sortableHeader}>
                          Job Title
                          {sortItem === "job_title" && sortOrder === "asc" && <ChevronDown />}
                          {sortItem === "job_title" && sortOrder === "desc" && <ChevronUp />}
                          {sortItem !== "job_title" && <Code className={styles.Normal} />}
                        </span>
                      </th>
                      <th onClick={() => changeSortOrder("role")} className={styles.clickableHeader}>
                        <span className={styles.sortableHeader}>
                          Permission Group
                          {sortItem === "role" && sortOrder === "asc" && <ChevronDown />}
                          {sortItem === "role" && sortOrder === "desc" && <ChevronUp />}
                          {sortItem !== "role" && <Code className={styles.Normal} />}
                        </span>
                      </th>
                      <th onClick={() => changeSortOrder("verification")} className={styles.clickableHeader}>
                        <span className={styles.sortableHeader}>
                          Verification
                          {sortItem === "verification" && sortOrder === "asc" && <ChevronDown />}
                          {sortItem === "verification" && sortOrder === "desc" && <ChevronUp />}
                          {sortItem !== "verification" && <Code className={styles.Normal} />}
                        </span>
                      </th>
                      <th onClick={() => changeSortOrder("hrMode")} className={styles.clickableHeader}>
                        <span className={styles.sortableHeader}>
                          HR Mode
                          {sortItem === "hrMode" && sortOrder === "asc" && <ChevronDown />}
                          {sortItem === "hrMode" && sortOrder === "desc" && <ChevronUp />}
                          {sortItem !== "hrMode" && <Code className={styles.Normal} />}
                        </span>
                      </th>
                      <th onClick={() => changeSortOrder("schedule")} className={styles.clickableHeader}>
                        <span className={styles.sortableHeader}>
                          Schedule
                          {sortItem === "schedule" && sortOrder === "asc" && <ChevronDown />}
                          {sortItem === "schedule" && sortOrder === "desc" && <ChevronUp />}
                          {sortItem !== "schedule" && <Code className={styles.Normal} />}
                        </span>
                      </th>
                      <th onClick={() => changeSortOrder("status")} className={styles.clickableHeader}>
                        <span className={styles.sortableHeader}>
                          Status
                          {sortItem === "status" && sortOrder === "asc" && <ChevronDown />}
                          {sortItem === "status" && sortOrder === "desc" && <ChevronUp />}
                          {sortItem !== "status" && <Code className={styles.Normal} />}
                        </span>
                      </th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.map((item, index) => {
                      if (perPage !== -1 && (index < page * perPage || index >= page * perPage + perPage)) return null;

                      const isSelected = selectedUser && selectedUser.id === item.id;
                      const roleClass =
                        item.role === "Technician" ? styles.roleTechnician :
                          item.role === "Security Guard" ? styles.roleSecurityGuard :
                            item.role === "Property Manager" ? styles.rolePropertyManager :
                              item.role === "Admin" ? styles.roleAdmin : styles.roleDefault;

                      return (
                        <tr
                          key={item.id}
                          className={`${styles.employeeRow} ${isSelected ? styles.selectedRow : ""}`}
                          onClick={() => OpenTaskDetails(item)}
                        >
                          <td>
                            <div className={styles.employeeCell}>
                              <div className={styles.avatarWrapper}>
                                <div className={styles.tableAvatar}>
                                  {item.user_image_url ? (
                                    <img src={item.user_image_url} alt={item.name} />
                                  ) : (
                                    item.initial
                                  )}
                                </div>
                                {/* <div className={`${styles.avatarDot} ${item.is_verified === 1 ? styles.avatarDotVerified : styles.avatarDotPending}`} /> */}
                              </div>
                              <div className={styles.empMeta}>
                                <span className={styles.empName}>{item.name}</span>
                                <span className={styles.empEmail}>{item.email}</span>
                                <span className={styles.empPhone}>{item.phone ? formatPhoneNumberIntl(item.isd_code + item.phone) : "—"}</span>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className={styles.propertyText}>
                              {item.property_arr?.[0] || "All Properties"}
                            </span>
                            {item.property_arr?.length > 1 && (
                              <span className={styles.propertyPill}>+{item.property_arr.length - 1}</span>
                            )}
                          </td>
                          <td>
                            <span className={`${styles.roleBadge} ${styles.roleDefault}`}>{item.job_title}</span>
                          </td>
                          <td>
                            <span className={`${styles.roleBadge} ${roleClass}`}>{item.role}</span>
                          </td>
                          <td>
                            <div className={styles.statusDotText}>
                              <span className={`${styles.statusDot} ${item.is_verified === 1 ? styles.dotVerified : styles.dotPending}`} />
                              {item.is_verified === 1 ? "Verified" : "Pending"}
                              {item.is_verified === 0 && item.country_code === "US" && (
                                <button
                                  className={styles.tableVerifyLinkBtn}
                                  onClick={(e) => { e.stopPropagation(); sendVerificationLink(item.id); }}
                                >
                                  Verify
                                </button>
                              )}
                            </div>
                          </td>
                          <td>
                            <div className={styles.statusDotText}>
                              <span className={`${styles.statusDot} ${item.is_hr_mode === 1 ? styles.dotOn : styles.dotOff}`} />
                              {item.is_hr_mode === 1 ? "On" : "Off"}
                            </div>
                          </td>
                          <td>
                            {item.is_hr_mode === 1 ? (
                              <div className={styles.scheduleDetails}>
                                <span className={styles.scheduleDays}>
                                  {item.working_days_arr?.length === 5 &&
                                    item.working_days_arr.includes("Mon") &&
                                    item.working_days_arr.includes("Fri") ? "Mon - Fri" : item.working_days_arr?.join(", ")}
                                </span>
                                <span className={styles.scheduleHours}>
                                  {item.checkin_time} - {item.checkout_time}
                                </span>
                              </div>
                            ) : (
                              "—"
                            )}
                          </td>
                          <td>
                            <span className={`${styles.statusBadge} ${item.is_archived === 1 ? styles.statusBadgeDisabled : styles.statusBadgeActive}`}>
                              {item.is_archived === 1 ? "Disabled" : "Active"}
                            </span>
                          </td>
                          <td style={{ position: "relative" }}>
                            {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("user:update") > -1 || user["https://propertydek.com/permissions"].indexOf("user:delete") > -1) && (
                              <Dropdown
                                show={activeDropdownId === item.id}
                                onToggle={(isOpen) => setActiveDropdownId(isOpen ? item.id : null)}
                                className={`${styles.ActionLeaseBUSec}`}
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
                              >
                                <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                                  <MoreVertical />
                                </Dropdown.Toggle>

                                <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                                  {item.country_code === "US" && item?.is_verified === 0 && (
                                    <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { e.stopPropagation(); sendVerificationLink(item.id); }}>
                                      <Send size={14} style={{ marginRight: "8px" }} /> Send Verification Link
                                    </Dropdown.Item>
                                  )}
                                  {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("user:update") > -1 && (
                                    <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { e.stopPropagation(); setArchiveModalOpen(true); setSelectecId(item.id); setIsArchive(item?.is_archived === 1); }}>
                                      {item?.is_archived === 1 ? <UserCheck size={14} style={{ marginRight: "8px" }} /> : <UserX size={14} style={{ marginRight: "8px" }} />} {item?.is_archived === 1 ? 'Enable' : 'Disable'}
                                    </Dropdown.Item>
                                  )}
                                  {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("user:delete") > -1 && (
                                    <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { e.stopPropagation(); setDeleteModalOpen(true); setSelectecId(item.id); }}>
                                      <Trash2 size={14} style={{ marginRight: "8px" }} /> Delete
                                    </Dropdown.Item>
                                  )}
                                </Dropdown.Menu>
                              </Dropdown>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}

            {/* Pagination Controls */}
            {filteredData.length > 0 && (
              <div className="Pagination TablePaginationNew List">
                <TablePagination
                  count={filteredData.length}
                  color="primary"
                  page={page}
                  rowsPerPage={perPage}
                  onPageChange={(e, v) => setPage(v)}
                  rowsPerPageOptions={[
                    { label: '4', value: 4 },
                    { label: '8', value: 8 },
                    { label: '16', value: 16 },
                    { label: 'All', value: -1 },
                  ]}
                  onRowsPerPageChange={(e) => {
                    setPage(0);
                    setPerPage(Number(e.target.value));
                  }}
                  labelRowsPerPage={'Employees per Page:'}
                />
              </div>
            )}

            {/* Empty State */}
            {!contentLoading && filteredData.length === 0 && (
              <div className={styles.NoDataMain}>
                <div className={styles.NoDataIMG}>
                  <img src="/static/img/no-prospect.png" alt="No Data" />
                </div>
                <p className={styles.NoDataText}>Employee list is empty</p>
                <p className={styles.NoDataTextSub}>It looks like no employees match the selected filters or none have been added yet.</p>
              </div>
            )}

          </div>}
        </div>
      </div>

      {/* Collapsible Details Panel */}
      <div
        className={prosDetails === true ? `${styles.ProspectDetailsPanel} ${styles.Open}` : `${styles.ProspectDetailsPanel}`}
        onClick={CloseTaskDetails}
      >
        <div className={`${styles.PanelUnder}`} onClick={(e) => e.stopPropagation()}>
          <UserDetails
            selectedUser={selectedUser}
            CloseTaskDetails={CloseTaskDetails}
            onUserUpdate={userUpdate}
            onArchive={(id, isArchived) => {
              setSelectecId(id);
              setIsArchive(isArchived);
              setArchiveModalOpen(true);
            }}
            onSendVerification={(id) => sendVerificationLink(id)}
            propertyList={propertyList}
            roleList={roleList}
          />
        </div>
      </div>

    </div>

    <Dialog
      open={deleteModalOpen}
      onClose={(e) => setDeleteModalOpen(false)}
      fullWidth
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">Would you like to delete this user?<button onClick={(e) => setDeleteModalOpen(false)}><X /></button></DialogTitle>
      <DialogContent>
        <div className="ModalFormGroup">
          <label className="PopupBodyText">The user information will be removed immediately. You can't undo this action.</label>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={(e) => confirmDelete()} className="CancelPopupBU">Delete</Button>
        <Button onClick={(e) => setDeleteModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={archiveModalOpen}
      onClose={(e) => setArchiveModalOpen(false)}
      fullWidth
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">Would you like to {isArchive ? 'enable' : 'disable'} this user?<button onClick={(e) => setArchiveModalOpen(false)}><X /></button></DialogTitle>
      <DialogContent>
        <div className="ModalFormGroup">
          <label className="PopupBodyText">The user information will be {isArchive ? 'enabled' : 'disabled'} immediately. You can undo this action at anytime.</label>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={(e) => confirmArchive()} className="CancelPopupBU">{isArchive ? 'Enable' : 'Disable'}</Button>
        <Button onClick={(e) => setArchiveModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={addModalOpen}
      onClose={(e) => { setAddModalOpen(false) }}
      fullWidth
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp MobileForm"
    >
      <DialogTitle id="alert-dialog-title">
        <button className={`${styles.BackAddBU}`} onClick={(e) => { setAddModalOpen(false) }}><ArrowLeft /></button>
        Add Employee
        <button onClick={(e) => { setAddModalOpen(false) }}><X /></button>
      </DialogTitle>
      <DialogContent>
        <UserAdd setAddModalOpen={setAddModalOpen.bind(this)} setLoading={setLoading.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} userAddLocal={userAdd.bind(this)} editData={null} />
      </DialogContent>
    </Dialog>

    <Dialog
      open={editModalOpen}
      onClose={(e) => { setEditModalOpen(false) }}
      fullWidth
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp MobileForm"
    >
      <DialogTitle id="alert-dialog-title">
        <button className={`${styles.BackAddBU}`} onClick={(e) => { setEditModalOpen(false) }}><ArrowLeft /></button>
        Update User
        <button onClick={(e) => { setEditModalOpen(false) }}><X /></button>
      </DialogTitle>
      <DialogContent>
        <UserAdd setAddModalOpen={setEditModalOpen.bind(this)} setLoading={setLoading.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} userAddLocal={userUpdate.bind(this)} />
      </DialogContent>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      onClose={(e) => setSnackbarOpen(false)}
      TransitionComponent={Slide}
      message={snackbarMsg}
      autoHideDuration={10000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={(e) => setSnackbarOpen(false)}
        >
          <X />
        </IconButton>
      }
    />

    <Footer />
  </>
  )
}

export default UserList;